import { render, staticRenderFns } from "./PopupStateDirectorRegAdmin.vue?vue&type=template&id=457630d6&"
import script from "./PopupStateDirectorRegAdmin.vue?vue&type=script&lang=js&"
export * from "./PopupStateDirectorRegAdmin.vue?vue&type=script&lang=js&"
import style0 from "./PopupStateDirectorRegAdmin.vue?vue&type=style&index=0&id=457630d6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports